import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "moudle6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ALLIES"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgUrl, (val, ind) => {
        return (_openBlock(), _createElementBlock("div", { key: ind }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgUrl[ind], (val_, ind_) => {
            return (_openBlock(), _createElementBlock("p", { key: ind_ }, [
              _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: val_,
                  alt: ""
                }, null, 8, _hoisted_4)
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}